import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
 import { buildRows } from '../assets/js/common'
 import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.DOMAIN_DNS_EMAIL_SERVER_MANAGEMENT)


const MANAGEMNT_TASK = [
  { title: 'Domain Management',desc: 'Domain registration, renewals, transfers, DNS configuration, records management, and ongoing domain support.' },
  { title: 'Business Email',      desc: 'Setup, migration, configuration, troubleshooting, mailbox management, security settings, and ongoing support for business email environments.' },
  { title: 'Website & Application Hosting',           desc: 'Reliable hosting environments for websites, web applications, databases, and business platforms with appropriate performance and security configurations.' },
  { title: 'DNS Management',  desc: 'Manage DNS records, routing, subdomains, email records, and domain configurations to keep your digital services connected correctly.' },
  { title: 'SSL & Security', desc: 'SSL certificate management and configuration to help secure websites, applications, and online communications.' },
  { title: 'Backup & Technical Support',   desc: 'Support for website and application backups, configuration issues, service interruptions, migrations, and day-to-day technical requirements.' },  
]

const AMC_MAINTENANCE  = [
   { name: 'Domains',    color: { bg: '#f7d3cf', text: '#7a3228' } },
 
  { name: 'DNS',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Business Email',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
 
  { name: 'Hosting',     color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'SSL',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'Backups',           color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Migrations',      color: { bg: '#dbd1fc', text: '#4a2d8a' }  },
  { name: 'Renewals',       color: { bg: '#f7d3cf', text: '#7a3228' } },
  { name: 'Technical Support',        color: { bg: '#9bcf60', text: '#2e5a0e' } },
  
]
 const AMC_MAINTENANCERows = buildRows(AMC_MAINTENANCE)
export default function DomainDNSEmailServerManagement() {
  

  return (
    <>
     {/* <MetaInfo
        title="Domain, Email & Hosting | CruxBytes"
        description="Manage domains, business email, hosting, DNS, SSL and website infrastructure with reliable support from CruxBytes."
        keywords="domain management, business email, web hosting, DNS management, SSL certificates, website infrastructure, CruxBytes"
      /> */}
       <MetaInfo
     title={label}
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Maintenance & Support -</div> */}
              <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Domain, Email & Hosting Services */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Simplify domain, DNS, email, and hosting management. */}
             {pageDesc}
             </p>
            
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
             {/* section 1 */}
                 <section className="bg-linear-gradient-light section-py" >
               <div className="container">
                  <p className="text-center" data-aos="fade-up">
                      Your domain, business email, DNS, hosting, and SSL infrastructure form the foundation of your digital presence. When these services are misconfigured or poorly managed, even a simple issue can affect your website, communication, and business operations.
                     </p>
                     <p className="text-center" data-aos="fade-up">
                      CruxBytes provides centralized management and technical support for these essential digital services. Whether you are a small business or corporates or MNC or PSUs, we cater to all businesses with only 1 intention, you manage your business we will take care of your digital assets. Our key services includes
                     </p>
                 
                      <div className="wcs-grid wcs-grid--3 pt-4">
                   {MANAGEMNT_TASK.map((card, i) => (
                     <div
                       key={card.title}
                       className="wcs-card-offer wcs-card-offer"
                       data-aos="fade-up"
                       data-aos-delay={(i % 3) * 80}
                     >
                       {/* <i className={`${card.icon} wcs-icon`} aria-hidden="true" /> */}
                       <h3 className="wcs-offer-title">{card.title}</h3>
                       <p className="wcs-offer-desc">{card.desc}</p>
                     </div>
                   ))}
                 </div>
                 
               </div>
             </section>
         
         {/* section 2 */}
               <section className="section-py text-center"  aria-label="Investing in our people" data-aos="fade-up">
                 <div className="container">
                    
                 <div  data-aos="fade-up">
                   <h2>
                    The Small Things That Keep Your Business Running
                   </h2>
                 </div>  
                     <div className="domain-grid pb-4" aria-label="List of industries we serve">
                         {AMC_MAINTENANCERows.map((row, rowIdx) => (
                           <div key={rowIdx} className="domain-row">
                             {row.map((domain, chipIdx) => (
                               <span
                                 key={domain.name}
                                 className="domain-chip"
                                 style={{ '--chip-bg': domain.color.bg, '--chip-text': domain.color.text }}
                                 data-aos="fade-up"
                                 data-aos-delay={chipIdx * 30}
                               >
                                 {domain.name}
                               </span>
                             ))}
                           </div>
                         ))}
                       </div>
                        <p className="section-px2" data-aos="fade-up">
                      Instead of managing multiple vendors and technical configurations separately, businesses can have a single technology partner managing these essential services.
                     </p>
                <div className="pt-4" data-aos="fade-up">
                   <h6>
                    Reliable Infrastructure Behind Your Digital Presence
                   </h6>
                 </div>          
                  <p className="section-px2" data-aos="fade-up" >
                  From domain and email setup to hosting, DNS, SSL, migrations, and ongoing support, CruxBytes helps keep your essential digital infrastructure connected, secure, and operational.
                  </p>
                  
                   </div>
                 </section>
         <TransformBanner />
         </main>

      </>
  )
}